module.exports = __webpack_public_path__ + "static/media/Engpic5@3x.58efbdbe.png";